/* Mega-Menü — Leinenweberei Hoffmann
   Hover-Intent (80ms), Klick-Toggle, Fokus-Navigation, Escape, Außenklick. */
(() => {
  const init = () => {
    const nav = document.querySelector('[data-mega-menu]');
    if (!nav) return;
    const items = [...nav.querySelectorAll('[data-mm-item]')];
    let hoverTimer = null;

    const closeAll = () => items.forEach((i) => {
      i.classList.remove('is-open');
      i.querySelector('[data-mm-trigger]')?.setAttribute('aria-expanded', 'false');
    });

    const open = (item) => {
      closeAll();
      item.classList.add('is-open');
      item.querySelector('[data-mm-trigger]')?.setAttribute('aria-expanded', 'true');
    };

    items.forEach((item) => {
      const trigger = item.querySelector('[data-mm-trigger]');

      item.addEventListener('mouseenter', () => {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => open(item), 80);
      });

      trigger?.addEventListener('click', (e) => {
        e.preventDefault();
        if (item.classList.contains('is-open')) {
          closeAll();
        } else {
          open(item);
        }
      });

      item.addEventListener('focusin', () => open(item));
    });

    nav.closest('header, store-header, .shopify-section--header')?.addEventListener('mouseleave', () => {
      clearTimeout(hoverTimer);
      closeAll();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-mega-menu]')) closeAll();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
